const Host = "http://appadmin.xhd.cn/";
export  default{
    Host
}




// WEBPACK FOOTER //
// ./src/libs/config.js